<template>
  <b-card>
    <b-card-title :title="title" class="big-title"/>
    <b-card-body>
      <slot>
      </slot>
    </b-card-body>
    <span v-html="footer"></span>
  </b-card>
</template>

<script>
export default {
  props: ['title', 'footer']
}
</script>
